import moment from 'moment'

import { DealerAPI } from 'src/api'

export default {
  namespaced: true,
  state: {
    trends: {},
    activeTrends: false,
    labels: {
      Sessions: {
        color: '#f2842f',
        active: true,
      },
      Leads: {
        color: '#47a089',
        active: false,
      },
      Sales: {
        color: '#ec5155',
        active: false,
      },
      CPL: {
        color: '#55395f',
        active: false,
      },
      CPS: {
        color: '#224166',
        active: false,
      },
    },
    channels: {
      Direct: {
        color: '#90527f',
        active: false,
      },
      Email: {
        color: '#000',
        active: false,
      },
      Display: {
        color: '#000',
        active: false,
      },
      Social: {
        color: '#329aca',
        active: false,
      },
      Referral: {
        color: '#3e5d7a',
        active: false,
      },
      'Paid Search': {
        color: '#ec5155',
        active: false,
      },
      '(Other)': {
        color: '#262626',
        active: false,
      },
      'Organic Search': {
        color: '#50ada5',
        active: false,
      },
    },
  },
  mutations: {
    SET_ACTIVE_TRENDS(state, payload) {
      state.activeTrends = payload
    },
    SET_ACTIVE_LABEL(state, { label, value }) {
      state.labels[label].active = value
    },
    SET_CHANNEL(state, { title, value }) {
      state.channels[title].active = value
    },
    SET_TRENDS(state, payload) {
      state.trends = payload
    },
  },
  actions: {
    async getTrends({ commit }) {
      const data = await DealerAPI.getStats().then((response) => {
        commit('SET_TRENDS', response.stats)
        commit('SET_ACTIVE_TRENDS', true)
      })
      return data
    },
    toggleChannel({ commit }, { title, active }) {
      commit('SET_CHANNEL', { title, value: !active })
    },
    toggleLabel({ commit, state }, label) {
      if (state.labels[label].active) {
        commit('SET_ACTIVE_LABEL', { label, value: false })
      } else {
        commit('SET_ACTIVE_LABEL', { label, value: true })
      }
    },
  },
  getters: {
    trendsLabel: (state, getters, rootState) => (tooltipItems, data) => {
      const { year } = rootState.settings
      const months = moment.months()
      const index = tooltipItems.index
      const dIndex = tooltipItems.datasetIndex
      return `${months[index]}\`${year.substr(2)} | ${data.datasets[dIndex].label}`
    },
    activeTrends(state) {
      return state.activeTrends
    },
    allTrendsChannel(state) {
      return {
        title: 'All',
        color: '#f49329',
        active: state.labels.Sessions.active,
        select: (store) => store.dispatch('trends/toggleLabel', 'Sessions'),
      }
    },
    trendsLabels(state, getters, rootState, rootGetters) {
      const { sessions, cpl, cps, leads, sales } = state.trends
      if (!sessions) {
        return []
      }
      return [sessions, leads, sales, cpl, cps].map((item) => ({
        ...item,
        dots: rootGetters['budget/getDataset'](item.dots),
        ...state.labels[item.title],
      }))
    },
    trendsChannels(state, getters, rootState, rootGetters) {
      return (
        state.trends.channels?.map((item) => ({
          ...item,
          dots: rootGetters['budget/getDataset'](item.dots),
          ...state.channels[item.title],
          select: (store, item) => store.dispatch('trends/toggleChannel', item),
        })) || []
      )
    },
    allStatsData(state, getters) {
      const channelsStats = getters.trendsChannels.reduce((acc, item) => {
        if (state.channels[item.title].active) {
          return acc.concat(item.dots)
        }
        return acc
      }, [])
      const labelsStats = getters.trendsLabels.reduce((acc, item) => {
        if (state.labels[item.title].active) {
          return acc.concat(item.dots)
        }
        return acc
      }, [])
      return [...channelsStats, ...labelsStats]
    },
    max(state, getters) {
      const stats = getters.allStatsData
      if (!stats[0]) {
        return 0
      }
      return Math.max.apply(null, stats)
    },
    middle(state, getters) {
      return Math.round(getters.max / 2)
    },
  },
}
